(function(window, mL_config, mL) {
    "use strict";

    if (!mL_config) throw new Error('The mL_config global is not available');
    if (!mL) throw new Error('The mL global is not available');

    var error_handler = false;
    var acive_version = false;
    var uid = false;
    var que = [];

    function set_uid() {
        if (uid || !error_handler) return;

        try {

            uid = mL.user.mlahart_uid();

            if (!uid) return;

            error_handler.setUser(uid);

        } catch (err) {
            console.error(err);
        }
    }

    function report_error(error) {
        if (!uid) set_uid();
        try {
            error_handler.report(error);
            console.error(error);
        } catch (err) {
            console.error(err);
        }
    }

    function init_handler() {
        var ver = false;

        try {
            ver = ver || mL.version();
            acive_version = ver.text;
        } catch (err) {
            acive_version = 'unknown_version';
        }

        try {
            error_handler = new StackdriverErrorReporter();
            error_handler.start({
                key: 'AIzaSyBhvlQPXXAXVpiYYd4py0nDxsN6RUWnUZA',
                projectId: 'mlahart-1151',
                service: mL_config.hostname || 'unknown_hostname',
                version: acive_version
            });
        } catch (err) {
            console.error('unable to start error handler', err);
        }

        try {
            if (que.length > 0) {
                for (var i = 0; i < que.length; i += 1) {
                    report_error(que[i]);
                }
                que = [];
            }
        } catch (err) {
            console.error('unable to process error que', err);
        }


    }

    function process_error(err) {
        //console.error(err);
        return (error_handler) ? report_error(err) : que.push(err);
    }


    mL.report_error = process_error;

    window.addEventListener("DOMContentLoaded", init_handler, false);

    window.mL_errors = process_error;
    try {
        window.onerror = function(message, source, lineno, colno, error) {
            var msg_arr = [];
            if (error) {
                return report_error(error);
            } else {
                if (message) msg_arr.push(message);
                if (source) msg_arr.push(source);
                if (lineno) msg_arr.push(lineno);
                if (colno) msg_arr.push(colno);
                return process_error(msg_arr.join(' | '));
            }
        };

    } catch (err) {
        console.error('unable to attach global error listener', err);
    }


}(window, window.mL_config, window.mL));